import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { Save, Play, ArrowLeft } from 'lucide-react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import FlowCanvas from '../FlowBuilder/FlowCanvas';
import NodePalette from '../FlowBuilder/NodePalette';
import NodeConfigPanel from '../../components/NodeConfigPanel';
import useFlowStore from '../../stores/flowStore';
import MainContainer from '../../components/MainContainer';
import MainHeader from '../../components/MainHeader';
import Title from '../../components/Title';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: 'flex',
    height: 'calc(100vh - 120px)',
  },
}));

const FlowBuilderCanvas = () => {
  const classes = useStyles();
  const history = useHistory();
  const { flowId } = useParams();
  const { t } = useTranslation();
  const { saveFlow, loadFlow, setFlowId, flowName, selectedNode, setSelectedNode, updateNode, deleteNode, duplicateNode} = useFlowStore();

  useEffect(() => {
    if (!flowId) return;
    setFlowId(flowId);
    loadFlow(flowId);
  }, [flowId, loadFlow, setFlowId]);

  const handleSave = async () => {
    const result = await saveFlow();
    if (result.success) {
      alert(t("flowBuilderCanvas.alerts.saved"));
    } else {
      alert(t("flowBuilderCanvas.alerts.saveError"));
    }
  };

  const handleTest = () => {
    alert(t("flowBuilderCanvas.alerts.testSoon"));
  };

  const handleBack = () => {
    history.push('/flowbuilders');
  };

  const handleSaveNodeConfig = (nodeId, config) => {
    updateNode(nodeId, { config });
    setSelectedNode(null);
  };

  const handleDeleteNode = (nodeId) => {
    if (window.confirm(t("flowBuilderCanvas.alerts.confirmDeleteNode"))) {
      deleteNode(nodeId);
      setSelectedNode(null);
    }
  };

  const handleDuplicateNode = (nodeId) => {
    duplicateNode(nodeId);
  };

  const handleClosePanel = () => {
    setSelectedNode(null);
  };

  return (
    <MainContainer>
      <MainHeader>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Button
            variant="outlined"
            onClick={handleBack}
            startIcon={<ArrowLeft size={20} />}
          >
            {t("flowBuilderCanvas.back")}
          </Button>
          <Title>
            {t("flowBuilderCanvas.title")} - {flowName}
          </Title>
        </div>
        <div style={{ display: 'flex', gap: 16 }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Play size={20} />}
            onClick={handleTest}
          >
            {t("flowBuilderCanvas.testFlow")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Save size={20} />}
            onClick={handleSave}
          >
            {t("flowBuilderCanvas.save")}
          </Button>
        </div>
      </MainHeader>

      <div className={classes.mainContainer}>
        <NodePalette />
        <div style={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
          <FlowCanvas />
          {selectedNode && (
            <div style={{
              position: 'absolute',
              top: 0,
              right: 0,
              height: '100%',
              zIndex: 10,
              animation: 'slideInRight 0.2s ease-out',
            }}>
              <NodeConfigPanel
                node={selectedNode}
                onClose={handleClosePanel}
                onSave={handleSaveNodeConfig}
                onDelete={handleDeleteNode}
                onDuplicate={handleDuplicateNode}
              />
            </div>
          )}
        </div>
      </div>
    </MainContainer>
  );
};

export default FlowBuilderCanvas;
